import { IEntityDto } from "./base";

export interface IActivityType extends IEntityDto {
  abbreviation?: string;
  activityTypeType?: string;
  activityTypeTypeTranslated?: string;
  articleDescription?: string;
  articleId?: number;
  articleNumber?: string;
  colour?: string;
  costTypeDescription?: string;
  costTypeId?: number;
  defaultDurationFriendly?: string;
  defaultDurationHours?: number;
  defaultDurationMinutes?: number;
  description?: string;
  isAtWork?: boolean;
  isBillable?: boolean;
  isPaid?: boolean;
}
